// Chakra Imports
import { Box, Flex, useColorModeValue, HStack, VStack } from "@chakra-ui/react";
import React from "react";
import ProjectNavbarLinks from "./ProjectNavbarLinks";

export default function ProjectNavbar({
  isSidebarCollapsed,
  onChatOpen,
  onOpen,
  onPathSelect,
  paths,
  selectedPath,
  shouldShowSearch,
}) {
  let navbarPosition = "absolute";
  let navbarFilter = "none";
  let navbarBackdrop = "none";
  let navbarShadow = "none";
  let secondaryMargin = "0px";
  let borderColor = useColorModeValue("gray.200", "gray.700");

  navbarPosition = "fixed";
  navbarShadow = useColorModeValue("0px 7px 23px rgba(0, 0, 0, 0.05)", "none");
  navbarFilter = useColorModeValue(
    "none",
    "drop-shadow(0px 7px 23px rgba(0, 0, 0, 0.05))"
  );

  return (
    <Flex
      alignItems="center"
      backdropFilter={navbarBackdrop}
      borderBottom="1px solid"
      borderColor={borderColor}
      boxShadow={navbarShadow}
      display="flex"
      filter={navbarFilter}
      justifyContent="center"
      lineHeight="25.6px"
      minH="75px"
      mt={secondaryMargin}
      mx="auto"
      pb="8px"
      position={navbarPosition}
      ps={"12px"}
      pt="8px"
      px="30px"
      right={0}
      top={0}
      transition-property="box-shadow, background-color, filter, border"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration=" 0.15s, 0.15s, 0.15s, 0s"
      transitionTimingFunction="linear, linear, linear, linear"
      w={`calc(100vw - ${isSidebarCollapsed ? "58px" : "320px"})`}
    >
      <Flex
        alignItems="center"
        flexDirection={{
          sm: "column",
          md: "row",
        }}
        w="100%"
      >
        <Box ms="auto" w="unset">
          <VStack align="stretch" spacing={2}>
            <HStack spacing={4}>
              <ProjectNavbarLinks
                onChatOpen={onChatOpen}
                onOpen={onOpen}
                onPathSelect={onPathSelect}
                paths={paths}
                selectedPath={selectedPath}
                shouldShowSearch={shouldShowSearch}
              />
            </HStack>
          </VStack>
        </Box>
      </Flex>
    </Flex>
  );
}
